var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMypageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5006 1.5C15.4274 1.50024 17.5918 3.84635 17.3726 6.80566C17.168 9.56432 15.0578 11.9997 12.5006 12C9.94392 12 7.82866 9.56574 7.62752 6.80469C7.40858 3.79436 9.57826 1.5 12.5006 1.5ZM12.5006 3C10.4542 3 8.96768 4.54952 9.12361 6.69531C9.28352 8.89165 10.9323 10.5 12.5006 10.5C14.0679 10.4997 15.7146 8.89177 15.8775 6.69434C16.0331 4.5916 14.542 3.00023 12.5006 3Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 13.5C16.7905 13.5 21.3668 15.8801 22.2212 20.6133C22.298 21.0391 22.2237 21.4955 21.9712 21.8643C21.7071 22.2499 21.2715 22.5 20.7495 22.5H4.24954C3.72772 22.5 3.29273 22.2496 3.02883 21.8643C2.77646 21.4955 2.70202 21.0391 2.77883 20.6133C3.63279 15.8801 8.20866 13.5 12.4995 13.5ZM12.4995 15C8.63442 15 4.93261 17.1198 4.25442 20.8799C4.24716 20.9201 4.24879 20.9539 4.25344 20.9785C4.25513 20.9873 4.25836 20.9944 4.26028 21H20.7388C20.7407 20.9944 20.7449 20.9875 20.7466 20.9785C20.7512 20.954 20.7529 20.9201 20.7456 20.8799C20.067 17.1197 16.3647 15 12.4995 15Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypageIcon);
export default __webpack_public_path__ + "static/media/mypageIcon.2511dbe2a099e454ef9c96739e3e843e.svg";
export { ForwardRef as ReactComponent };